import request from '@/utils/request'

export function getSysDictionariesList(data) {
  return request.post('/sys-dictionaries/list', data)
}

export function wxJsConfig(data) {
  return request.post('/wx-js', data)
}

export function verifyCode(data) {
  return request.post('/track/verify-code', data)
}

export function trackBindGoods(data) {
  return request.post('/track/bind-goods', data)
}

export function getExpressDeliveryList(data) {
  return request.post('/express-delivery/list', data)
}

export function getPayAgreedList(data) {
  return request.post('/pay-agreed/list', data)
}

export function getPayTypeList(data) {
  return request.post('/pay-type/list', data)
}

export function getEventList(data) {
  return request.post('/event/list', data)
}

export function getNoticeList(data) {
  return request.post('/notice/list', data)
}

export function addNotice(data) {
  return request.post('/notice/add', data)
}

export function readNotice(data) {
  return request.post('/notice/read', data)
}

export function getOrderCode(data) {
  return request.post('/order/code', data)
}



// WEBPACK FOOTER //
// ./src/api/commons.js